import Vue from 'vue'
import { Select, Tooltip } from 'ant-design-vue'
import { savePreviousData } from '@/services/api'

Vue.use(Select)
Vue.use(Tooltip)
export default Vue.extend({
  template: `
    <div class="a-gcell">
      <a-spin :spinning="loadingData">
        <a-auto-complete 
          class="w-100" 
          size="small"
          v-model="value" 
          :value="value" 
          :autoFocus="true" 
          @focus="savePreviousData(value)"
          @select="handleChange"
        >
          <template slot="dataSource">
            <a-select-option
              v-for="item in dropDownList"
              :key="item.option"
              :value="item.option"
            >
              {{item.value}} - {{item.option}}
            </a-select-option>
          </template>
        </a-auto-complete>
      </a-spin>
    </div>
    `,
  data() {
    return {
      loadingData: false,
      dropDownList: [],
      value: undefined,
      savePreviousData: savePreviousData,
      factor: undefined,
      oldValue: undefined,
    }
  },
  beforeMount() {
    this.dropDownList = this.params.colDef.cellRendererParams.dropdownData
  },
  created() {
    this.factor = null
    this.value = this.params.value
      ? String(this.params.value)
      : this.params.value
  },
  methods: {
    handleChange(value) {
      this.factor = this.params.colDef.cellRendererParams.dropdownData.find(
        i => i.option === value,
      )
      if (this.factor) {
        this.value = this.factor.value
      }
      this.params.api.tabToNextCell()
    },
    getValue() {
      if (this.factor) {
        return this.factor.value
      } else {
        return this.value
      }
    },
  },
})
